import React, { useState } from "react";
import { toast } from "react-toastify";
import ContentNetworkLayer from "../../helpers";

export default function AddSubject() {
  const [name, setName] = useState("");
  const [level, setLevel] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const isValid = name.trim() && level && description.trim();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValid) return;
    setLoading(true);
    try {
      await ContentNetworkLayer.createSubject({
        name: name.trim(),
        description: description.trim(),
        level,
      });
      toast.success("Subject added successfully!");
      setName("");
      setLevel("");
      setDescription("");
    } catch (error) {
      toast.error("Failed to add subject. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-card">
      <div className="form-card-header">
        <h2>Add Subject</h2>
        <p>Create a new subject for the Ace It platform.</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="field-row">
          <div className="field-group">
            <label className="field-label">Subject Name</label>
            <input
              className="field-input"
              type="text"
              placeholder="e.g. Mathematics"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="field-group">
            <label className="field-label">Level</label>
            <select
              className="field-select"
              value={level}
              onChange={(e) => setLevel(e.target.value)}
            >
              <option value="">Select level...</option>
              <option value="CAPE">CAPE</option>
              <option value="CSEC">CSEC</option>
              <option value="PEP">PEP</option>
            </select>
          </div>
        </div>

        <div className="field-group">
          <label className="field-label">Description</label>
          <textarea
            className="field-textarea"
            placeholder="Brief description of this subject..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div className="form-footer">
          <span />
          <div className="form-footer-actions">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isValid || loading}
            >
              {loading ? "Adding..." : "Add Subject"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
